(function ($) {
    $(document).ready(function() {
        /* Thumbnails owlcarousel en News*/
        setTimeout(function(){
        let items = $('.news__images#thumbnails .owl-item').length;
            if (items <= 1) {
                $('.news__images#thumbnails').hide();
            }
        });
    });
})(jQuery, Drupal);

/*
(function ($) {
    $(document).ready(function() {
        if ($('.block-researcher').length) {
          let sidebarHeight = $('.block-researcher').parent().height();
          let bodyHeight = $('.news__body').height();
          let imagesHeight = $('.block--images').height();
          if (sidebarHeight > bodyHeight) {
            let totalHeight = sidebarHeight + imagesHeight;
            $('.news__body').closest('.col-12').css('height', totalHeight+'px')
          }
        }
    });
})(jQuery, Drupal);
*/

(function (Drupal, once) {
  "use strict";

  /**
   * Coloca la columna lateral de la noticia (.news__participants).
   *
   * En el DOM esa columna es una sección de Layout Builder hermana de la del
   * cuerpo, y en escritorio el CSS la saca de flujo con position:absolute para
   * meterla en el hueco derecho, debajo de la galería. Eso obliga a darle un
   * "top", y el CSS sólo puede darlo en rem: seis valores fijos combinando
   * .multiple-images y .footer-images con los dos breakpoints.
   *
   * Ninguno puede acertar, porque la altura de la galería depende del número de
   * imágenes, de la proporción de cada una, de si llevan pie y de la tira de
   * miniaturas que irb_owlcarousel.js clona en tiempo de ejecución: cuando el
   * CSS se aplica, esa tira todavía no existe.
   *
   * Aquí se mide sobre el maquetado ya montado (ver BLOCKERS) y se publican dos
   * custom properties en el <article>:
   *
   *   --news-participants-top      dónde empieza la columna lateral.
   *   --news-participants-reserve  alto mínimo de la sección del cuerpo. Al
   *                                estar absoluta, la columna no ocupa sitio y
   *                                las secciones siguientes suben por debajo;
   *                                esto les reserva el hueco.
   *
   * El CSS conserva los valores en rem como fallback de cada var(), así que si
   * este script no llega a ejecutarse el maquetado queda exactamente como
   * estaba.
   */

  var DESKTOP = "(min-width: 992px)";

  /**
   * Elementos por debajo de los cuales tiene que empezar la columna lateral.
   *
   * La galería porque flota a la derecha y ocupa el hueco de la columna. Y
   * .news__lead porque no lleva max-width: mientras la galería está a su lado
   * el float le acorta las líneas, pero en cuanto la pasa se extiende al ancho
   * completo y se metería debajo de la columna. (.news__body no hace falta:
   * está limitado al 74%.)
   */
  var BLOCKERS = [".block--images", ".news__lead"];

  /**
   * Recalcula y publica las dos medidas.
   *
   * @param {Element}   article      El .news--full.
   * @param {Element}   section      La sección del cuerpo (.pre-header).
   * @param {Element[]} blockers     Elementos que la columna no puede pisar.
   * @param {Element}   participants La columna lateral (.news__participants).
   */
  function update(article, section, blockers, participants) {
    var style = article.style;

    // Por debajo de 992 la columna va en flujo normal: no hay nada que situar
    // ni que reservar, y dejar las medidas puestas rompería el apilado.
    if (!window.matchMedia(DESKTOP).matches) {
      style.removeProperty("--news-participants-top");
      style.removeProperty("--news-participants-reserve");
      return;
    }

    var articleTop = article.getBoundingClientRect().top;

    // El más bajo de los dos manda. En la galería basta con su caja: como
    // flota, ya incluye los márgenes de #picture y #thumbnails.
    var top = blockers.reduce(function(lowest, element) {
      return Math.max(lowest, element.getBoundingClientRect().bottom - articleTop);
    }, 0);

    // La sección del cuerpo tiene que llegar al menos hasta donde acabe la
    // columna lateral. Se mide desde el inicio de la sección, no del article,
    // por si algún día deja de ser el primer hijo.
    var sectionTop = section.getBoundingClientRect().top - articleTop;
    var reserve = top + participants.offsetHeight - sectionTop;

    style.setProperty("--news-participants-top", Math.round(top) + "px");
    style.setProperty("--news-participants-reserve", Math.ceil(reserve) + "px");
  }

  Drupal.behaviors.newsParticipants = {
    attach: function (context) {
      once("newsParticipants", ".news--full", context).forEach(function (article) {
        var section = article.querySelector(".pre-header");
        var participants = article.querySelector(".news__participants");
        var blockers = [];

        if (section) {
          BLOCKERS.forEach(function(selector) {
            var element = section.querySelector(selector);

            if (element) {
              blockers.push(element);
            }
          });
        }

        // Sin columna lateral, o sin nada por encima de lo que colocarla, no
        // hay solape posible.
        if (!section || !participants || !blockers.length) {
          return;
        }

        var pending = false;

        function run() {
          if (pending) {
            return;
          }

          pending = true;
          window.requestAnimationFrame(function() {
            pending = false;
            update(article, section, blockers, participants);
          });
        }

        run();

        // La galería crece cuando cargan las imágenes y otra vez cuando Owl
        // monta el carrusel y clona las miniaturas, y el lead cambia de alto al
        // reflowear. En lugar de intentar acertar con el momento, se observan
        // sus cajas: sirve para todos esos casos y para cualquier otro.
        //
        // Se observan los blockers y la columna lateral. La sección no, que es
        // donde escribimos el min-height y realimentaría al observador.
        if (window.ResizeObserver) {
          var observer = new ResizeObserver(run);

          blockers.forEach(function(element) {
            observer.observe(element);
          });
          observer.observe(participants);
        } else {
          window.addEventListener("load", run);
        }

        window.addEventListener("resize", run);
      });
    }
  };
})(Drupal, once);
